import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type RetailLocationTemplateConfiguration = {
    organizationalUnitColumnMappings: Record<Uuid, Uuid>;
    userTemplateAccessPolicies: Record<Uuid, RetailLocationUserTemplateAccessPolicy>;
};

export enum RetailLocationUserTemplateAccessPolicyType {
    all = "8343bd0e-6a10-4c0b-99f2-152c0e6aff69",
    none = "173aeb72-cab9-4dd0-a2d7-edffb0f9d93c",
    organizationalUnits = "0128dc48-6d46-4e97-bd01-4cabe4cf3763",
}

export type RetailLocationUserTemplateAccessPolicy =
    | {
          type: RetailLocationUserTemplateAccessPolicyType.all;
      }
    | {
          type: RetailLocationUserTemplateAccessPolicyType.none;
      }
    | {
          organizationalUnitColumnId: Uuid;
          type: RetailLocationUserTemplateAccessPolicyType.organizationalUnits;
      };

export const retailLocationUserTemplateAccessPolicyValidator: zod.ZodType<RetailLocationUserTemplateAccessPolicy> = zod.discriminatedUnion("type", [
    zod.strictObject({type: zod.literal(RetailLocationUserTemplateAccessPolicyType.all)}),
    zod.strictObject({type: zod.literal(RetailLocationUserTemplateAccessPolicyType.none)}),
    zod.strictObject({
        organizationalUnitColumnId: uuidZodValidator,
        type: zod.literal(RetailLocationUserTemplateAccessPolicyType.organizationalUnits),
    }),
]);

export const retailLocationTemplateConfigurationValidator: zod.ZodType<RetailLocationTemplateConfiguration> = zod.strictObject({
    organizationalUnitColumnMappings: zod.record(uuidZodValidator, uuidZodValidator),
    userTemplateAccessPolicies: zod.record(uuidZodValidator, retailLocationUserTemplateAccessPolicyValidator),
});
